import { render } from "./AttachedFile.vue?vue&type=template&id=35967d3d"
import script from "./AttachedFile.vue?vue&type=script&lang=js"
export * from "./AttachedFile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__